module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/haircut-desktop@2x-45e7802c14a844a100ec00cbff9cc6c9.jpg";